import React, { FC } from 'react';
import styled from '@emotion/styled';
import { IEnrichedProduct } from '$models';
import { useTranslation } from '$hooks';
import { Flex } from '$components/layouts';
import { VariantCarousel } from './variant-carrousel';
import { formatString, isSpecialPrice, mq } from '$lib/helpers';

type Props = {
    selectedVariant: IEnrichedProduct;
    variants: IEnrichedProduct[];
};

export const NonBookVariant: FC<Props> = ({ selectedVariant, variants }: Props): JSX.Element => {
    const { translate } = useTranslation();
    const { product } = selectedVariant;

    return (
        <ProductDetailsMargin>
            {!!variants && variants?.length > 1 && (
                <VariantCarousel products={variants} selectedVariantNumber={product?.itemNumber} />
            )}
            {isSpecialPrice(selectedVariant.activePrice?.accountRelation) ? (
                <Flex gap={'extrasmall'}>
                    <span>{`${translate('productPage.productDetails.priceB2CLabel')} `}</span>
                    <SpecialPrice>{selectedVariant.activeAmountAsText}</SpecialPrice>
                </Flex>
            ) : (
                <>
                    {selectedVariant.inActivePrice && (
                        <InActivePriceContainer gap={'extrasmall'}>
                            <div>{translate('productPage.productDetails.retailPriceB2CLabel')}</div>
                            <InActivePrice>{selectedVariant.inActiveAmountAsText}</InActivePrice>
                        </InActivePriceContainer>
                    )}
                    <Flex gap={'extrasmall'}>
                        <span>{`${translate('productPage.productDetails.priceB2CLabel')} `}</span>
                        <Price>{selectedVariant.activeAmountAsText}</Price>
                    </Flex>
                    {selectedVariant.inActivePrice && !!selectedVariant.rebatePercent && (
                        <div>
                            {formatString(
                                translate('productPage.productDetails.discountPercentageLabel'),
                                Math.round(selectedVariant.rebatePercent)
                            )}
                        </div>
                    )}
                </>
            )}
        </ProductDetailsMargin>
    );
};

const Price = styled.span(({ theme }) => ({
    fontWeight: theme.fontWeights.bold,
    fontsize: theme.fontSizes.md,
}));

const SpecialPrice = styled.span(({ theme }) => ({
    fontWeight: theme.fontWeights.bold,
    fontsize: theme.fontSizes.md,
    color: theme.colors.primaryTheme,
}));

const InActivePriceContainer = styled(Flex)(({ theme }) => ({
    color: theme.colors.primaryGrey,
}));

const InActivePrice = styled.div({
    textDecoration: 'line-through',
});

const ProductDetailsMargin = styled.div(({ theme }) => ({
    marginBottom: theme.space[4],
    [mq('frame')]: {
        // paddingLeft: theme.space[6],
        // paddingRight: theme.space[6],
    },
}));
